import { isEqual } from 'lodash'

import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'RulesGeneratorText',

  mixins: [ proxy({ type: 'array' }) ],

  methods: {
    _inputFilter(data) {
      return data.map(item => {
        return { text: item }
      })
    },

    _outputFilter(data) {
      return data.map(item => {
        return item.text
      }).filter(item => {
        return item !== undefined
      })
    },

    transmitValue() {
      const proxy = this._outputFilter(this.proxy)
      if (!isEqual(proxy, this.value)) {
        this.$emit('input', proxy)
      }
    }
  },

  render
}
